import React, { useEffect } from "react";
// material
import {
  Box,
  Grid,
  Container,
  Typography,
  CardHeader,
  CardContent
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
// import { styled } from "@mui/material/styles";

// components
import Page from "../components/Page";
import {
  CheckedPostDocTable,
  CheckedPhDTable
} from "../components/_dashboard/app";

// ----------------------------------------------------------------------
const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

export default function Checked() {
  const { role, user: currentUser } = useSelector((state) => state.authReducer);

  return (
    <Page title="Checked">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">Checked</Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={12}>
            <CardHeader title="PostDoc" />
            <CardContent>
              <CheckedPostDocTable checkPostDocList={[]} />
            </CardContent>
          </Grid>

          <Grid item xs={12} md={6} lg={12}>
            <CardHeader title="PhD" />
            <CardContent>
              <CheckedPhDTable checkPhDList={[]} />
            </CardContent>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
